import React from 'react'
import { styled } from 'styletron-react'
import logo from './eh-logo.svg'

const Frame = styled('div', ({ $fadeOut }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  background: '#fff',
  position: 'fixed',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  transition: 'opacity 0.3s linear',
  opacity: $fadeOut ? 0 : 1,
  zIndex: '9999',
}))

const Content = styled('div', {
  width: '200px',
})

const Logo = styled('img', {
  width: '200px',
  marginBottom: '10px'
})

const LoadingFrame = styled('div', {
  width: '100%',
  height: '10px',
  background: 'rgba(0,0,0,.1)',
})

const LoadingBar = styled('div', ({ $width, $done }) => ({
  height: '10px',
  width: $width ? $width + '%' : '10%',
  transition: 'width 0.2s ease-in-out, background-color 0.2s linear',
  backgroundColor: $done ? 'hsl(120,80%,70%)' : 'rgba(0,0,0,.7)',
  boxShadow: `0px 2px 20px  ${$done ? 'hsla(120,80%,70%, 0.3)' : 'rgba(0,0,0,.3)'}`
}))

class Overlay extends React.Component {
  state = {
    width: 10,
    fadeOut: false,
    done: false
  }
  componentDidMount() {
    setTimeout(() => {
      this.increment(40)
    }, 1000)
    setTimeout(() => {
      this.increment(50)
    }, 1500)
    setTimeout(() => {
      this.setState({ done: true })
    }, 1800)
    setTimeout(() => {
      this.setState({ fadeOut: true })
    }, 2500)
    setTimeout(() => {
      this.props.hideOverlay()
    }, 2800)
  }
  increment = width => {
    if (this.state.width + width > 100) return
    this.setState({ width: this.state.width + width })
  }
  render() {
    return (
      <Frame $fadeOut={this.state.fadeOut}>
        <Content>
          <Logo src={logo} />
          <LoadingFrame>
            <LoadingBar $width={this.state.width} $done={this.state.done} />
          </LoadingFrame>
        </Content>
      </Frame>
    )
  }
}

export default Overlay


// WEBPACK FOOTER //
// ./src/common/Overlay/index.js